interface FilterRowProps {
  label: string;
  options: string[];
  value: string;
  onChange: (value: string) => void;
}

export default function FilterRow({ label, options, value, onChange }: FilterRowProps) {
  const allOptions = ["全部", ...options];
  return (
    <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4 py-3 border-b border-background-200 last:border-b-0">
      <span className="shrink-0 text-sm font-medium text-foreground-500 sm:w-16 sm:pt-1">{label}</span>
      <div className="flex flex-wrap gap-2">
        {allOptions.map((option) => {
          const active = value === option;
          return (
            <button
              key={option}
              type="button"
              onClick={() => onChange(option)}
              className={`h-8 px-3 rounded-md text-xs md:text-sm font-medium whitespace-nowrap transition-colors ${
                active
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-50 text-foreground-600 border border-background-200 hover:text-primary-500 hover:border-primary-300"
              }`}
            >
              {option}
            </button>
          );
        })}
      </div>
    </div>
  );
}